import { useTranslation } from 'react-i18next';
import styles from './AmountSummary.module.css';

interface AmountWarningProps {
    /**
     * Amount that actually reaches the machine, in currency units. Passed only
     * when a campaign makes it differ from what the card is charged — then the
     * warning has to name the larger number, not the one on the card.
     */
    machineAmount?: number;
    currencyLabel?: string;
}

const WarningIcon = (): React.JSX.Element => (
    <svg
        className={styles.icon}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        aria-hidden="true"
    >
        <path d="M9 1.5 17.2 16H0.8L9 1.5Z" fill="currentColor" />
        <path d="M9 6.6v4.2" stroke="#fdffff" strokeWidth="1.6" strokeLinecap="round" />
        <circle cx="9" cy="13.3" r="0.9" fill="#fdffff" />
    </svg>
);

/**
 * The warning that has to reach the buyer at the moment of the decision, not as
 * a static banner above the screen — see SWRN-1800. It sits inside the amount
 * card so that the sum being sent and its consequence read as one statement.
 */
const AmountWarning = ({
    machineAmount,
    currencyLabel,
}: AmountWarningProps): React.JSX.Element => {
    const { t } = useTranslation();

    const text = typeof machineAmount === 'number'
        ? t('Machine charges one product with discount', {
            amount: machineAmount.toFixed(2),
            currency: currencyLabel,
        })
        : t('Machine charges one product');

    return (
        <p className={styles.warning}>
            <WarningIcon />
            <span>{text}</span>
        </p>
    );
};

export { AmountWarning };
